module.exports = __webpack_public_path__ + "img/browser-firefox.79b3bfe9.svg";